import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Departamento, Dispositivo, Empregador } from '../../api.service';

@Component({
  selector: 'app-painel-dados-terminal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './painel-dados-terminal.component.html'
})
export class PainelDadosTerminalComponent {
  @Input() empregadores: Empregador[] = [];
  @Input() departamentos: Departamento[] = [];
  @Input() empregadorSelecionado = '';
  @Input({ required: true }) terminal!: Dispositivo;
  @Input() importando = false;
  @Input() ligandoFoto = false;

  @Output() empregadorSelecionadoChange = new EventEmitter<string>();
  @Output() terminalChange = new EventEmitter<Dispositivo>();
  @Output() importarServidores = new EventEmitter<void>();
  @Output() ligarFotoMonitor = new EventEmitter<void>();

  get ehIdFace() {
    return (this.terminal?.tipo || '').toUpperCase() === 'IDFACE';
  }

  emitirTerminal() {
    this.terminalChange.emit(this.terminal);
  }

  alterarDepartamentos(ids: string[]) {
    this.terminal.departamentoIds = ids;
    this.emitirTerminal();
  }
}
